import toPropertyKey$1 from './to-property-key.js';
import './object-define-property.js';
import createPropertyDescriptor$1 from './create-property-descriptor.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var toPropertyKey = toPropertyKey$1;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$1;

var createProperty = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
};

export { createProperty as default };
